var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.99968C17 9.49968 16.5 11.4997 14.1 12.2997C14.8 10.5997 14.9 8.89968 14.4 7.29968C13.7 5.19968 11.4 3.59968 9.8 2.69968C9.4 2.39968 8.7 2.79968 8.8 3.39968C8.8 4.49968 8.5 6.09968 6.8 7.79968C4.6 9.99968 3.5 12.2997 3.5 14.4997C3.5 17.3997 5.5 20.9997 9.5 20.9997C5.5 16.9997 8.5 13.4997 8.5 13.4997C9.3 19.3997 13.5 20.9997 15.5 20.9997C17.2 20.9997 20.5 19.7997 20.5 14.5997C20.5 11.4997 19.2 9.09968 18.1 7.69968C17.8 7.19968 17.1 7.49968 17 7.99968",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.ea486064fa30407c19c0c6c206a7195e.svg";
export { ForwardRef as ReactComponent };